<script setup>
import { onMounted, inject } from 'vue'
import { v4 as uuidv4 } from 'uuid'

const anthill = inject('$anthill')
const modulePlayerId = `module-player-${uuidv4()}`
const props = defineProps({
  videoId: {
    type: [Number, Boolean],
    default: false
  },
  autoplay: {
    type: Boolean,
    default: false
  },
  videoImage: {
    type: Object,
    default() {
      return {}
    }
  },
  volumeLevel: {
    type: Number,
    default: 1
  }
})

function initPlayer() {
  anthill.tvplayer3loader.loadPlayer(function (_error, _tvplayer3core, _container) {
    if (_error) {
      console.error('Loading player3 error!') // eslint-disable-line no-console
      return
    }

    const TOKENIZER_HOST = encodeURI(window.__tokenizerHost)

    const player = _tvplayer3core.createPlayer()
    player.init({
      container: _container,
      videoID: props.videoId,
      seekToTime: 0,
      endPointData:
        `${TOKENIZER_HOST}/shared/player2withoutTokenizer/api.dist.php?@method={{method}}&id={{id}}`,
      endPointToken: `${TOKENIZER_HOST}/tokenizer/token/{{id}}`,
      gplayerAccountId: 'AotLcG7O0IySPlFwVR9l8aRu.j06bC7gKvd07qoHXzf.67',
      gstreamAccountId: '.F4wq3hgS5eecNPg4Did0qdFPzfs128ifYRHR21h1Ij.r7',
      autoplay: props.autoplay,
      volumeLevel: props.volumeLevel,
      useDataLayer: true
    })
  }, `.${modulePlayerId}`)
}

onMounted(() => {
  initPlayer()
})
</script>

<template>
  <div class="vue-player">
    <div :class="modulePlayerId" />
  </div>
</template>
